import React from 'react'
import { Image, Modal } from 'antd'
import { IChatVideo } from 'models/chat'
import { getChatImageUrl } from './utils'
import styles from './ChatsPage.module.scss'

interface IChatMessageMediaProps {
  images?: string[]
  videos?: IChatVideo[]
}

// Видео, как и фото, открывается по нажатию: в пузыре только обложка
export const ChatMessageMedia: React.FC<IChatMessageMediaProps> = ({ images = [], videos = [] }) => {
  const [openedVideo, setOpenedVideo] = React.useState<IChatVideo | null>(null)

  return (
    <div className={`${styles.messageImages} ${images.length + videos.length === 1 ? styles.messageImagesSingle : ''}`}>
      {videos.map((video) => (
        <button
          key={video.src}
          type='button'
          className={`${styles.messageImage} ${styles.messageVideo}`}
          onClick={() => setOpenedVideo(video)}
          aria-label='Смотреть видео'
        >
          <img src={getChatImageUrl(video.poster)} alt='' />
          <span className={styles.playBadge} aria-hidden />
        </button>
      ))}
      <Image.PreviewGroup>
        {images.map((key) => (
          <Image
            key={key}
            src={getChatImageUrl(key)}
            alt='Фото из чата'
            rootClassName={styles.messageImage}
            preview={{ mask: null }}
          />
        ))}
      </Image.PreviewGroup>
      <Modal open={Boolean(openedVideo)} onCancel={() => setOpenedVideo(null)} footer={null} centered destroyOnClose width={720}>
        {openedVideo && (
          <video
            src={getChatImageUrl(openedVideo.src)}
            poster={getChatImageUrl(openedVideo.poster)}
            controls
            autoPlay
            playsInline
            className={styles.videoPlayer}
          />
        )}
      </Modal>
    </div>
  )
}
